<xemex-select-field class="block max-w-md" [label]="label() | translate">
  <mat-select
    data-testid="installation-device-select"
    [hideSingleSelectionIndicator]="true"
    [value]="selected()"
    (valueChange)="selected.set($event)"
  >
    @for (option of options(); track option.deviceId) {
      <mat-option [value]="option.deviceId">{{ option.label }}</mat-option>
    }
  </mat-select>
</xemex-select-field>
